<template>
  <sdPageHeader :title="$t('pages.tickets.list.title')">
    <template v-slot:buttons>
      <div class="page-header-actions">
        <router-link :to="'/tickets/create'">
          <sdButton size="large" type="primary">
            <sdFeatherIcons type="plus" size="14" />
            {{ $t('pages.tickets.list.create-ticket') }}
          </sdButton>
        </router-link>
      </div>
    </template>
  </sdPageHeader>
  <Main>
    <sdCards>
      <a-row :gutter="16">
        <a-col :span="4">
          <label> {{ $t('pages.tickets.list.label-status') }} </label>
          <a-select
            :placeholder="$t('common.choose')"
            style="width: 100%"
            v-model:value="filter.status"
            @change="onFilterChange"
          >
            <a-select-option :value="null">
              {{ $t('common.choose') }}
            </a-select-option>
            <a-select-option v-for="(item, index) in this.status" :key="index" :value="item">
              {{ $t('pages.tickets.list.' + item) }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="4">
          <label> {{ $t('pages.tickets.list.label-priority') }} </label>
          <a-select
            :placeholder="$t('common.choose')"
            style="width: 100%"
            v-model:value="filter.priority"
            @change="onFilterChange"
          >
            <a-select-option :value="null">
              {{ $t('common.choose') }}
            </a-select-option>
            <a-select-option :value="'normal'">
              {{ $t('pages.tickets.list.normal') }}
            </a-select-option>
            <a-select-option :value="'danger'">
              {{ $t('pages.tickets.list.important') }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="4">
          <label> &nbsp;</label>
          <sdButton size="default" :outlined="true" type="success" style="width: 100%" @click="onClickFilter">
            {{ $t('common.filter') }}
          </sdButton>
        </a-col>
        <a-col :span="4">
          <label> &nbsp;</label>
          <SearchBoxVue v-model:text="filter.search" @text-changed="getTableData()" />
        </a-col>
      </a-row>
      <br />

      <a-row :gutter="25">
        <a-col :sm="24" :xs="24">
          <div v-if="isLoading" class="spin">
            <a-spin />
          </div>
          <div v-else>
            <a-table
              class="table-responsive"
              :columns="columns"
              :data-source="tableContent"
              :pagination="{
                pageSize: this.filter.pageSize,
                showSizeChanger: true,
                total: this.filter.total,
                current: this.filter.current,
              }"
              @change="onTableChange"
              size="small"
            >
              <template #status_title="{ record }">
                <a-space>
                  <a-tag :color="record.status_color">
                    {{ $t('pages.tickets.list.' + record.status) }}
                  </a-tag>
                </a-space>
              </template>

              <template #priority_title="{ record }">
                <a-space>
                  <a-tag :color="record.priority_title == 'Normal' ? 'green' : 'red'">
                    {{
                      record.priority_title == 'Normal'
                        ? $t('pages.tickets.list.normal')
                        : $t('pages.tickets.list.important')
                    }}
                  </a-tag>
                </a-space>
              </template>

              <template #action="{ record }">
                <a-space>
                  <a-tooltip placement="top">
                    <template #title>
                      <span>{{ $t('common.reply') }}</span>
                    </template>
                    <router-link :to="'/tickets/detail/' + record.key">
                      <a-button type="primary">
                        <template #icon> <sdFeatherIcons type="corner-up-left" style="color: white" /> </template>
                      </a-button>
                    </router-link>
                  </a-tooltip>
                </a-space>
              </template>
            </a-table>
          </div>
        </a-col>
      </a-row>
    </sdCards>
  </Main>
</template>

<script>
import { Main } from '@/view/styled';
import { dateToTr } from '@/utility/helper.js';

export default {
  components: {
    Main,
  },
  data() {
    return {
      isFilterNew: false,
      isLoading: true,
      tableContent: [],
      status: ['solved', 'unsolved', 'in_process', 'pending', 'waiting_for_reply'],
      filter: {
        current: 1,
        pageSize: 10,
        total: null,
        priority: null,
        status: null,
      },
      columns: [
        {
          title: this.$t('pages.tickets.list.table-code'),
          dataIndex: 'code',
          key: 'code',
        },
        {
          title: this.$t('pages.tickets.list.table-title'),
          dataIndex: 'title',
          key: 'title',
        },
        {
          title: this.$t('pages.tickets.list.table-staff-name'),
          dataIndex: 'staff_name_surname',
          key: 'staff_name_surname',
        },
        {
          title: this.$t('pages.tickets.list.table-state'),
          dataIndex: 'status',
          key: 'status_title',
          slots: { customRender: 'status_title' },
        },
        {
          title: this.$t('pages.tickets.list.table-priority'),
          dataIndex: 'priority_title',
          key: 'priority_title',
          slots: { customRender: 'priority_title' },
        },
        {
          title: this.$t('pages.tickets.list.table-record-date'),
          dataIndex: 'record_time',
          key: 'record_time',
        },
        {
          title: this.$t('pages.tickets.list.table-action'),
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  methods: {
    onClickFilter() {
      this.isFilterNew = true;
      this.filter.current = 1;
      this.getData();
      this.isFilterNew = false;
    },
    onTableChange(e) {
      this.filter.current = this.isFilterNew ? 1 : e.current;
      this.filter.pageSize = e.pageSize;
      this.getData();
      this.isFilterNew = false;
    },
    onFilterChange(e) {
      this.isFilterNew = true;
    },
    getData() {
      this.isLoading = true;
      this.$appAxios
        .post(this.$endpoints.ticket_get, this.filter)
        .then((resp) => {
          if (resp.data.status === true) {
            var tableRecords = resp.data.data.tableData || [];
            this.filter.total = resp.data.data.total || 0;
            this.tableContent = [];
            var _this = this;
            tableRecords.forEach(function (item, index) {
              _this.tableContent.push({
                key: item.id,
                record_time: dateToTr(item.record_time) || '-',
                code: item.code,
                title: item.title,
                staff_name_surname: item.staff_name + ' ' + item.staff_surname,
                status: item.status,
                status_color: item.status_color,
                priority_title: item.priority_title,
              });
            });
          } else {
            this.$message.error(resp.data.message);
          }
          this.isLoading = false;
        })
        .catch((e) => {
          this.$message.error(this.$t('common.error-message'));
          this.isLoading = false;
        });
    },
  },
  created() {
    this.getData();
  },
};
</script>
